export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// API base URL resolution.
//
// In every Emergent-hosted environment (preview AND production) the frontend
// and backend are served from the same origin via the platform ingress.
// Therefore window.location.origin is always the correct backend base URL.
//
// We still honor REACT_APP_BACKEND_URL for explicit overrides (e.g. local dev
// running on localhost:3000 talking to a backend at localhost:8001) BUT we
// automatically ignore the env value when it points to a different host than
// the one we are currently served from. This makes the app resilient when a
// deployment secret is stale (e.g. still pointing to a preview URL after the
// app was promoted to a custom domain).
function resolveApiBase() {
  if (typeof window === "undefined") {
    return process.env.REACT_APP_BACKEND_URL || "";
  }
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (!envUrl) return window.location.origin;
  try {
    const envHost = new URL(envUrl).host;
    if (envHost === window.location.host) return envUrl;
    return window.location.origin;
  } catch {
    return window.location.origin;
  }
}

const API = resolveApiBase();

export async function authFetch(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  return res;
}
